var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PU_TO_NU } from "../../constants/NcodeConstants";
import { NeoPdfManager } from "../../neopdf/NeoPdfManager";
import CalibrationData from "../Calibration/CalibrationData";
import { MappingStorage } from "../MappingStorage";
// type INuMarginCalcCallbackType = (pageNo: number) => { Xmin: number, Ymin: number, Xmax: number, Ymax: number };
const nprojMarginToMinMax = (pageNo, nprojMargins) => {
    var _a, _b, _c, _d;
    const marginItem = nprojMargins[pageNo];
    const m = marginItem;
    const Xmin = ((_a = m.nu) === null || _a === void 0 ? void 0 : _a.Xmin) ? m.nu.Xmin : m.crop_margin.left * PU_TO_NU;
    const Ymin = ((_b = m.nu) === null || _b === void 0 ? void 0 : _b.Ymin) ? m.nu.Ymin : m.crop_margin.top * PU_TO_NU;
    const Xmax = ((_c = m.nu) === null || _c === void 0 ? void 0 : _c.Xmax) ? m.nu.Xmax : ((m.whole.x2 - m.whole.x1) - m.crop_margin.right) * PU_TO_NU;
    const Ymax = ((_d = m.nu) === null || _d === void 0 ? void 0 : _d.Ymax) ? m.nu.Ymax : ((m.whole.y2 - m.whole.y1) - m.crop_margin.bottom) * PU_TO_NU;
    return { Xmin, Ymin, Xmax, Ymax };
};
const getNprojPdfSize = (pageNo, nprojMargins) => {
    var _a, _b;
    const marginItem = nprojMargins[pageNo];
    const m = marginItem;
    const width = ((_a = m.pu) === null || _a === void 0 ? void 0 : _a.width) ? m.pu.width : (m.whole.x2 - m.whole.x1) - (m.crop_margin.left + m.crop_margin.right);
    const height = ((_b = m.pu) === null || _b === void 0 ? void 0 : _b.height) ? m.pu.height : (m.whole.y2 - m.whole.y1) - (m.crop_margin.top + m.crop_margin.bottom);
    return { width, height };
};
export function manualRegisterAtMappingStorage(item) {
    return __awaiter(this, void 0, void 0, function* () {
        const pagesPerSheet = 1;
        /** homography를 구하기 위해서 CalibrationData를 쓴다 */
        const worker = new CalibrationData();
        // Page info를 세팅하고 나서
        const { section, owner, book, startPage: page, numPages } = item;
        const pageInfos = Array.from({ length: numPages }, (v, i) => { return { section, owner, book, page: page + i }; });
        worker.setNcodePageinfos(numPages, pageInfos);
        const { pdf_url_for_mapper: pdf_url, filename, fingerprint } = item;
        // PDF 정보를 세팅
        const pdfPageDesc = {
            url: pdf_url, filename, fingerprint, numPages,
            id: fingerprint + `/${pagesPerSheet}`,
            pageNo: 1,
            size_pu: getNprojPdfSize(0, item.nprojMargins),
        };
        worker.setPdfDesc(pdfPageDesc);
        // 각 페이지 별로, calibration data를 배열로 세팅한다.
        const ptsArr = [];
        const toAvoidZero_pu = 10; // pu의 p0가 0이 들어가면 계산이 이상하기 때문
        const toAvoidZero_nu = toAvoidZero_pu * PU_TO_NU;
        // pdf size를 넣을 곳
        const size_pu_arr = [];
        const l = item.nprojMargins.length;
        for (let i = 0; i < numPages; i++) {
            let pdfPageSize = { width: 210 / 25.4 * 72, height: 297 / 25.4 * 72 };
            pdfPageSize = getNprojPdfSize(i, item.nprojMargins);
            size_pu_arr.push(pdfPageSize);
            let nu_margin;
            if (i < l) {
                nu_margin = nprojMarginToMinMax(i, item.nprojMargins);
            }
            else {
                nu_margin = nprojMarginToMinMax(0, item.nprojMargins);
            }
            const l_nu = nu_margin.Xmin + toAvoidZero_nu;
            const t_nu = nu_margin.Ymin + toAvoidZero_nu;
            const r_nu = nu_margin.Xmax - toAvoidZero_nu;
            const b_nu = nu_margin.Ymax - toAvoidZero_nu;
            const nu = {
                p0: { x: l_nu, y: t_nu },
                p1: { x: r_nu, y: t_nu },
                p2: { x: r_nu, y: b_nu },
                p3: { x: l_nu, y: b_nu }
            };
            const l_pu = 0 + toAvoidZero_pu;
            const t_pu = 0 + toAvoidZero_pu;
            const r_pu = pdfPageSize.width - toAvoidZero_pu;
            const b_pu = pdfPageSize.height - toAvoidZero_pu;
            const pu = {
                p0: { x: l_pu, y: t_pu },
                p1: { x: r_pu, y: t_pu },
                p2: { x: r_pu, y: b_pu },
                p3: { x: l_pu, y: b_pu }
            };
            ptsArr.push({ pageNo: i + 1, pts: { nu, pu } });
        }
        const loadingTask = NeoPdfManager.getInstance().getDocument({
            url: item.pdf_url_for_mapper,
            filename: item.filename,
            purpose: "MAIN DOCUMENT: to be opend by NeoPdfViewer"
        });
        const pdfDoc = yield loadingTask;
        const mapper = worker.createDocMapperItemPageByPage(filename, numPages, ptsArr, size_pu_arr, item.background_image_url_rule, pdfDoc, pagesPerSheet);
        // 2021/08/12
        // 그 다음 등록
        const msi = MappingStorage.getInstance();
        msi.register(mapper);
    });
}
//# sourceMappingURL=RegisterPdfInAdvance.js.map